import React, { useState } from "react";
import SecondaryButton from "../../common/buttons/SecondaryButton";

const MetaAdsSelector = ({ data, onSubmit, selectedAccount, setSelectedAccount, selectedAdAccount, setSelectedAdAccount, setIsLoading, setAccountDetails }) => {
    const [error, setError] = useState("");

    if (!data) return null;

    const handleSubmit = () => {
        if (!selectedAccount || !selectedAdAccount) {
            setError("Please select both an account and an ad account.");
            return;
        }
        setError("");
        onSubmit();
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-[black] bg-opacity-50">
            <div className="p-6 bg-white shadow-lg rounded-lg w-[318px]">
                <h2 className="text-lg font-semibold mb-5 text-[#1B2A3D]">Select an Account</h2>
                <div className="pb-1">
                {data.accounts.map((account) => (
                    <label key={account.id} className="flex items-center space-x-2 mb-4">
                        <input
                            type="radio"
                            name="account"
                            value={account.id}
                            checked={selectedAccount === account.id}
                            onChange={() => setSelectedAccount(account.id)}
                            className="fb-custom-radio"
                        />
                        <span className="text-[#010101]">{account.name}</span>
                    </label>
                ))}
                </div>
                <div className="h-[1px] border_light_blue_div_bg"></div>
                <h2 className="text-lg font-semibold mt-4 mb-5 text-[#1B2A3D]">Select an Ad Account</h2>
                {data.adAccounts.map((adAccount) => (
                    <label key={adAccount.id} className="flex items-center space-x-2 mb-4">
                        <input
                            type="radio"
                            name="adAccount"
                            value={adAccount.id}
                            checked={selectedAdAccount === adAccount.id}
                            onChange={() => setSelectedAdAccount(adAccount.id)}
                            className="fb-custom-radio"
                        />
                        <span className="text-[#010101]">{adAccount.account_id}</span>
                    </label>
                ))}

                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

                <div className="mt-7 flex">
                    <button
                        onClick={handleSubmit}
                        className=" btn-primary-base-bar primary_btn flex items-center bg-[#245CEA] text-white py-2 px-5 rounded-[5px] hover:bg-white border hover:border-[#245CEA] hover:text-[#1A1A1B] transition duration-300 h-[42px] text-[16px] font-mont font-[600] mr-5"
                    >
                        Submit
                    </button>
                    <SecondaryButton label="Cancel" onClick={() => setAccountDetails(false)} />
                </div>
            </div>
        </div>
    );
};

export default MetaAdsSelector;
